import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  type DeparturePageHookProps,
  useDeparturePageContainer,
  FlightExchangeSearchSelectors,
  FlightExchangeThunk,
  FlightPostBookingSelectors,
} from "@b2bportal/core-flights";
import type { AppDispatch } from "@b2bportal/core-types";
import { useExchangeDeparturePageFetch } from "./useExchangeDeparturePageFetch";

export const useExchangeDeparturePage = (props: DeparturePageHookProps) => {
  useExchangeDeparturePageFetch(props);

  const dispatch = useDispatch<AppDispatch>();
  const exchangeForType = useSelector(
    FlightExchangeSearchSelectors.getExchangeForType
  );
  const originalReservationId = useSelector(
    FlightPostBookingSelectors.getSelectedFlightItinerary
  ).data?.bookedItinerary.id;

  const onErrorReload = useCallback(() => {
    if (originalReservationId == null) return;
    dispatch(
      FlightExchangeThunk.fetchExchangeFlights({
        originalReservationId,
        exchangeType: {
          AirExchangeForType: exchangeForType.exchangeFor,
          outboundSelection: {
            ExchangeAction: exchangeForType.outboundSelection,
          },
          ...(exchangeForType.returnSelection != null
            ? {
                returnSelection: {
                  ExchangeAction: exchangeForType.returnSelection,
                },
              }
            : {}),
        } as any,
      })
    );
  }, [dispatch, exchangeForType, originalReservationId]);

  return useDeparturePageContainer({
    goToNextStep: props.goToNextStep,
    onErrorReload,
  });
};
